export const RECEIVE_MOTD = 'chat/RECEIVE_MOTD';
export const SET_MOTD_START = 'chat/SET_MOTD_START';
export const SET_MOTD_COMPLETE = 'chat/SET_MOTD_COMPLETE';

export const RECEIVE_MESSAGE = 'chat/RECEIVE_MESSAGE';
export const SEND_MESSAGE = 'chat/SEND_MESSAGE';

export const NOTIFY = 'chat/NOTIFY';
export const LOG = 'chat/LOG';

export const REMOVE_MESSAGE = 'chat/REMOVE_MESSAGE';
export const REMOVE_USER_MESSAGES = 'chat/REMOVE_USER_MESSAGES';
export const REMOVE_ALL_MESSAGES = 'chat/REMOVE_ALL_MESSAGES';

export const MUTE_USER = 'chat/MUTE_USER';
export const UNMUTE_USER = 'chat/UNMUTE_USER';
